import { render } from "./Panchanga.vue?vue&type=template&id=289c9548&scoped=true"
import script from "./Panchanga.vue?vue&type=script&lang=js"
export * from "./Panchanga.vue?vue&type=script&lang=js"

import "./Panchanga.vue?vue&type=style&index=0&id=289c9548&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289c9548"]])

export default __exports__